import { Box, Typography } from "@mui/material";
import React from "react";

type PasswordRulesChecklistProps = {
  password: string;
};

const passwordRules = [
  {
    id: "len",
    test: (v: string) => v.length >= 12 && v.length <= 20,
    label: "12-20 characters",
  },
  {
    id: "upper",
    test: (v: string) => /[A-Z]/.test(v),
    label: "At least one uppercase letter",
  },
  {
    id: "lower",
    test: (v: string) => /[a-z]/.test(v),
    label: "At least one lowercase letter",
  },
  {
    id: "digit",
    test: (v: string) => /\d/.test(v),
    label: "At least one number",
  },
  {
    id: "symbol",
    test: (v: string) => /[^A-Za-z0-9]/.test(v),
    label: "At least one symbol",
  },
];

const PasswordRulesChecklist: React.FC<PasswordRulesChecklistProps> = ({
  password,
}) => {
  return (
    <Box className="bg-color_F8F8F8 rounded-lg p-4">
      <Typography className="text-sm mb-2">
        Password must meet all rules:
      </Typography>
      <ul className="list-disc pl-5 space-y-1">
        {passwordRules.map((rule) => {
          const passed = rule.test(password || "");
          return (
            <li
              key={rule.id}
              className={passed ? "text-green-600" : "text-gray-600"}
            >
              {rule.label}
            </li>
          );
        })}
      </ul>
    </Box>
  );
};

export default PasswordRulesChecklist;
